const MAX_PAYLOAD_SIZE = 50000; // 50KB

export const processPayload = (
  payload: Record<string, unknown> | unknown,
): string => {
  try {
    const stringifiedPayload = JSON.stringify(payload);

    if (stringifiedPayload === undefined) {
      return JSON.stringify({
        value: String(payload),
        type: typeof payload,
      });
    }

    // Limit overall payload size to 50KB
    if (stringifiedPayload.length > MAX_PAYLOAD_SIZE) {
      const truncated = stringifiedPayload.substring(0, MAX_PAYLOAD_SIZE);
      return `${truncated}... [PAYLOAD_TRUNCATED]`;
    }

    return stringifiedPayload;
  } catch (error) {
    return JSON.stringify({
      serializationError: 'Failed to serialize error payload',
      error: error instanceof Error ? error.message : String(error),
    });
  }
};
